import { useContext } from 'react';
import {
  GlobalDrawersContext,
  GlobalDrawersContextType,
} from './global-drawer.context';

export const useGlobalDrawersContext = () => {
  const context = useContext(GlobalDrawersContext);

  /* istanbul ignore next */
  if (!context) throw new Error('Global drawer context is not defined.');

  return context;
};

export const useGlobalDrawer = <T extends keyof GlobalDrawersContextType>(
  name: T,
): GlobalDrawersContextType[T] => useGlobalDrawersContext()[name];
